"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _currency = _interopRequireDefault(require("currency.js"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _LanguageProvider = require("../../framework/LanguageProvider/LanguageProvider.index");

var _Badge = _interopRequireDefault(require("../Badge/Badge.index"));

var _Price = require("./Price.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Price = function Price(_ref) {
  var alignment = _ref.alignment,
      badge = _ref.badge,
      className = _ref.className,
      inline = _ref.inline,
      prefix = _ref.prefix,
      price = _ref.price,
      _ref$promo = _ref.promo,
      promo = _ref$promo === void 0 ? {} : _ref$promo,
      savingsText = _ref.savingsText,
      size = _ref.size,
      suffix = _ref.suffix,
      theme = _ref.theme,
      extraPriceInfo = _ref.extraPriceInfo;
  var _theme$price = theme.price;
  _theme$price = _theme$price === void 0 ? {} : _theme$price;
  var _theme$price$showCent = _theme$price.showCentsDelimiter,
      showCentsDelimiter = _theme$price$showCent === void 0 ? true : _theme$price$showCent,
      _theme$price$superscr = _theme$price.superscriptCents,
      superscriptCents = _theme$price$superscr === void 0 ? false : _theme$price$superscr,
      _theme$price$superscr2 = _theme$price.superscriptCurrency,
      superscriptCurrency = _theme$price$superscr2 === void 0 ? false : _theme$price$superscr2,
      _theme$price$showExte = _theme$price.showExternalPromo,
      showExternalPromo = _theme$price$showExte === void 0 ? false : _theme$price$showExte;
  var percentOff = !showExternalPromo && promo.percentOff && promo.percentOff > 0 && promo.percentOff / 100;
  var stackablePercentOff = promo.stackablePercentage && promo.stackablePercentage > 0;
  var discount = (0, _react.useMemo)(function () {
    return percentOff && (0, _currency["default"])(price).multiply(percentOff).value;
  }, [percentOff, price]);
  var displayPrice = (0, _react.useMemo)(function () {
    return discount ? (0, _currency["default"])(price).subtract(discount).value : price;
  }, [discount, price]);
  var hasPrice = !!displayPrice;

  var _useContext = (0, _react.useContext)(_LanguageProvider.LanguageContext),
      translate = _useContext.translate,
      translateCurrency = _useContext.translateCurrency,
      translateCurrencyToSimpleParts = _useContext.translateCurrencyToSimpleParts;

  var translatedPrice = translateCurrencyToSimpleParts(displayPrice);
  var savingsTextDisplay = savingsText || !!discount && "".concat(translate('Save', _LanguageProvider.LangCasing.cap), " ").concat(parseInt(promo.percentOff, 10), "%");
  var shouldShowBadge = (0, _react.useMemo)(function () {
    return theme.badges && theme.badges.includes(badge);
  }, [badge, theme.badges]); // whole, decimal, literal, fraction, currency

  function renderPrice() {
    var priceParts = [];
    var cents = [];
    var hasCents = false;

    if (shouldShowBadge) {
      priceParts.push( /*#__PURE__*/_react["default"].createElement(_Price.StyledBadge, {
        size: size
      }, /*#__PURE__*/_react["default"].createElement(_Badge["default"], {
        name: badge,
        size: size
      })));
    }

    translatedPrice.forEach(function (part) {
      switch (part.type) {
        case 'whole':
          priceParts.push( /*#__PURE__*/_react["default"].createElement("span", null, part.value));
          break;

        case 'decimal':
          if (showCentsDelimiter && superscriptCents || !superscriptCents) {
            cents.push( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, part.value));
          }

          break;

        case 'fraction':
          cents.push( /*#__PURE__*/_react["default"].createElement("span", null, part.value));
          hasCents = true;
          break;

        case 'currency':
          priceParts.push( /*#__PURE__*/_react["default"].createElement(_Price.StyledCurrency, {
            hasBadge: shouldShowBadge,
            size: size,
            superscriptCurrency: superscriptCurrency
          }, theme.price.currency));
          break;

        default:
          priceParts.push( /*#__PURE__*/_react["default"].createElement("span", null, part.value));
      } // Append the cents


      if (hasCents) {
        if (superscriptCents) {
          priceParts.push( /*#__PURE__*/_react["default"].createElement(_Price.StyledCents, null, cents));
        } else {
          priceParts.push(cents);
        }

        hasCents = false;
      }
    });
    return priceParts;
  }

  return /*#__PURE__*/_react["default"].createElement(_Price.StyledContainer, {
    alignment: alignment,
    className: className,
    itemprop: "offers",
    itemScope: true,
    itemType: "http://schema.org/Offer"
  }, /*#__PURE__*/_react["default"].createElement("meta", {
    itemProp: "priceCurrency",
    content: theme.price.currency
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    itemProp: "price",
    content: displayPrice
  }), /*#__PURE__*/_react["default"].createElement("link", {
    itemProp: "availability",
    href: "http://schema.org/InStock"
  }), prefix && /*#__PURE__*/_react["default"].createElement(_Price.StyledPrefix, {
    size: size,
    alignment: alignment,
    inline: inline
  }, prefix), /*#__PURE__*/_react["default"].createElement(_Price.StyledPromo, {
    alignment: alignment
  }, !!percentOff && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Price.StyledStrikethrough, {
    alignment: alignment,
    size: size
  }, translateCurrency(price)), /*#__PURE__*/_react["default"].createElement(_Price.StyledSavings, {
    alignment: alignment,
    size: size
  }, savingsTextDisplay)), showExternalPromo && /*#__PURE__*/_react["default"].createElement(_Price.StyledExternalPromo, {
    alignment: alignment,
    size: size
  }, savingsTextDisplay)), hasPrice ? /*#__PURE__*/_react["default"].createElement(_Price.StyledPrice, {
    size: size,
    theme: theme,
    alignment: alignment,
    inline: inline
  }, renderPrice()) : /*#__PURE__*/_react["default"].createElement(_Price.StyledPrice, {
    size: size,
    theme: theme,
    alignment: alignment
  }, "N/A"), extraPriceInfo && /*#__PURE__*/_react["default"].createElement(_Price.StyledExtraPriceInfo, null, extraPriceInfo), !!stackablePercentOff && /*#__PURE__*/_react["default"].createElement(_Price.StyledPromoStackable, {
    alignment: alignment
  }, /*#__PURE__*/_react["default"].createElement(_Price.StyledSavings, null, "+ ".concat(translate('Extra', _LanguageProvider.LangCasing.cap), " ").concat(promo.stackablePercentage, "%"))), suffix && /*#__PURE__*/_react["default"].createElement(_Price.StyledSuffix, {
    inline: inline
  }, suffix), !showExternalPromo && promo.productDescription ? /*#__PURE__*/_react["default"].createElement(_Price.StyledPromoDescription, null, promo.productDescription) : null);
};

Price.defaultProps = {
  alignment: 'left',
  badge: undefined,
  className: undefined,
  inline: false,
  prefix: undefined,
  promo: undefined,
  savingsText: undefined,
  size: 'normal',
  suffix: undefined,
  extraPriceInfo: undefined
};
Price.propTypes = {
  /** Alignment of the labels */
  alignment: (0, _propTypes.oneOf)(['left', 'center', 'right']),

  /** Show a badge before the price. Available badges are listed on the `badges` array of the theme file (/src/themes/{theme}/index.js). */
  badge: _propTypes.string,

  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** Whether to display the price as a block or inline */
  inline: _propTypes.bool,

  /** Price prefix. Shown before the price value. */
  prefix: _propTypes.string,

  /** Price */
  price: _propTypes.number.isRequired,

  /** Percentage off */
  promo: (0, _propTypes.shape)({
    percentOff: _propTypes.number,
    stackablePercentage: _propTypes.number
  }),

  /** Promotional text */
  savingsText: _propTypes.string,

  /** Display size */
  size: (0, _propTypes.oneOf)(['small', 'normal', 'text']),

  /** Price suffix. Shown after the price value. */
  suffix: _propTypes.string,

  /** Theme object. Passed automatically by the ThemeProvider high-order component. */
  theme: (0, _propTypes.shape)({}).isRequired,
  extraPriceInfo: (0, _propTypes.oneOf)([_propTypes.string, _propTypes.node])
};
Price.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Price",
  "props": {
    "promo": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Percentage off",
      "type": {
        "name": "shape",
        "value": {
          "percentOff": {
            "name": "number",
            "required": false
          },
          "stackablePercentage": {
            "name": "number",
            "required": false
          }
        }
      },
      "required": false
    },
    "alignment": {
      "defaultValue": {
        "value": "'left'",
        "computed": false
      },
      "description": "Alignment of the labels",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'left'",
          "computed": false
        }, {
          "value": "'center'",
          "computed": false
        }, {
          "value": "'right'",
          "computed": false
        }]
      },
      "required": false
    },
    "badge": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Show a badge before the price. Available badges are listed on the `badges` array of the theme file (/src/themes/{theme}/index.js).",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "inline": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Whether to display the price as a block or inline",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "prefix": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Price prefix. Shown before the price value.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "savingsText": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Promotional text",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "size": {
      "defaultValue": {
        "value": "'normal'",
        "computed": false
      },
      "description": "Display size",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'normal'",
          "computed": false
        }, {
          "value": "'text'",
          "computed": false
        }]
      },
      "required": false
    },
    "suffix": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Price suffix. Shown after the price value.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "extraPriceInfo": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "import { bool, node, number, oneOf, shape, string } from 'prop-types';",
          "computed": true
        }, {
          "value": "import { bool, node, number, oneOf, shape, string } from 'prop-types';",
          "computed": true
        }]
      },
      "required": false
    },
    "price": {
      "description": "Price",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "theme": {
      "description": "Theme object. Passed automatically by the ThemeProvider high-order component.",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(Price);

exports["default"] = _default;